if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.closeOtherImageWithTextAccordions(activeDetails);
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      closeOtherImageWithTextAccordions(activeDetails) {
        const imageWithTextSection = activeDetails.closest('.image-with-text');
        if (!imageWithTextSection) return;

        const openDetails = imageWithTextSection.querySelectorAll('.image-with-text__collapsible .accordion-details[open]');
        openDetails.forEach((details) => {
          if (details !== activeDetails) {
            details.open = false;
            details.setAttribute('aria-expanded', 'false');
            this.handleClose(details);
          }
        });
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        details.setAttribute('aria-expanded', 'true');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        details.setAttribute('aria-expanded', 'false');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
